export enum LogType {
  ActionLog = 1,
  ErrorLog = 2,
  SystemLog = 3,
}

export enum LogAction {
  Login = 'Login',
  Logout = 'Logout',
  ShowDialog = 'ShowDialog',
  ChangeScreen = 'ChangeScreen',
}

/**
 * If modify ScreenName please check and update logLogoutLinkToScreenName
 * These comments's items are used in BE
 */
export enum ScreenName {
  login = 'ログイン画面',
  businessManagement = '事業所管理',
  // businessManagementSetting = '調査用Passのログイン設定ダイアログ',
  // businessManagementSettingOptionManagement = 'オプション管理ダイアログ',
  // businessManagementDeleteLiveRole = 'Liveのロール削除ダイアログ',
  accountManagement = 'アカウント管理',
  // accountManagementDetail = 'アカウントの詳細ダイアログ',
  // accountManagementDeleteLiveRole = 'Liveのロール削除ダイアログ',
  notifications = 'ユーザー向けメール送信',
  // notificationsSendListPreview = '送信リストダイアログ',
  // notificationsViewSentList = '送信済リストダイアログ',
  help = 'システムからのお知らせ',
  // helpUseTemplate = 'テンプレートリストダイアログ',
  useTermManagement = '利用規約管理',
  settingsUpdates = 'システム管理',
  loginNotice = 'ログイン前のお知らせ',
  ccjAdmin = 'CCJ-Admin管理',
  role = 'LiveConsoleロール管理',
}

/**
 * Usage: LOG_LOGOUT_LINK_TO_SCREEN_NAME.find(v => v.link.indexOf(pathname) >= 0)?.keyScreenName || '';
 */
export const LOG_LOGOUT_LINK_TO_SCREEN_NAME = [
  {
    link: 'business-management',
    keyScreenName: 'businessManagement',
  },
  {
    link: 'account-management',
    keyScreenName: 'accountManagement',
  },
  {
    link: 'sd/send-mail',
    keyScreenName: 'notifications',
  },
  {
    link: 'help',
    keyScreenName: 'help',
  },
  {
    link: 'use-term-management',
    keyScreenName: 'useTermManagement',
  },
  {
    link: 'settings-updates',
    keyScreenName: 'settingsUpdates',
  },
  {
    link: 'sd/login-notice',
    keyScreenName: 'loginNotice',
  },
  {
    link: 'admin-role/ccj-admin',
    keyScreenName: 'ccjAdmin',
  },
  {
    link: 'admin-role/role-management',
    keyScreenName: 'role',
  },
];
